import { useEffect, useRef } from "react";

export function useScrollRestoration(key, isReady) {
  const isRestored = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      window.sessionStorage.setItem(`scroll_${key}`, window.scrollY.toString());
    };
    
    // Use passive listener for performance
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [key]);

  useEffect(() => {
    // Only attempt restoration once after the component unmounts/remounts and data is ready
    if (isReady && !isRestored.current) {
      const savedScroll = window.sessionStorage.getItem(`scroll_${key}`);
      if (savedScroll) {
        // Small timeout allows DOM to fully paint/expand before scrolling
        setTimeout(() => {
          window.scrollTo({ top: parseInt(savedScroll, 10), behavior: 'instant' });
        }, 50);
      }
      isRestored.current = true;
    }
  }, [key, isReady]);
}
